import apiClient from './apiClient';

// Planilla histórica: lo que el estudio tenía en las solapas CARPETAS ELIMINADAS y ARCHIVO del
// Excel. No son clientes del sistema: se vinculan por CUIL. Ver PlanillaHistoricaController.

export const ORIGENES = {
    CARPETA_ELIMINADA: 'Carpetas eliminadas',
    ARCHIVO: 'Archivo',
};

/** Una página del listado de una solapa. */
export async function listarPlanilla(origen, page = 0, size = 50, texto = '', filtros = {}) {
    const params = { origen, page, size };
    if (texto && texto.trim()) params.texto = texto.trim();
    if (filtros.tramite && filtros.tramite.trim()) params.tramite = filtros.tramite.trim();
    if (filtros.anio) params.anio = filtros.anio;
    if (filtros.seguimiento) params.seguimiento = filtros.seguimiento;
    const { data } = await apiClient.get('/planilla-historica', { params });
    return data;
}

/** Coincidencias en las dos solapas, para la búsqueda de Clientes. */
export async function buscarEnPlanilla(texto, limite = 10) {
    const { data } = await apiClient.get('/planilla-historica/buscar', { params: { texto, limite } });
    return Array.isArray(data) ? data : [];
}

/** Las filas de un cliente (ficha y aviso de "ya fue cliente"). */
export async function planillaDeCliente(cuil) {
    const { data } = await apiClient.get(`/clientes/${cuil}/planilla-historica`);
    return Array.isArray(data) ? data : [];
}

export async function opcionesSeguimiento() {
    const { data } = await apiClient.get('/planilla-historica/opciones-seguimiento');
    return Array.isArray(data) ? data : [];
}

/** Cambia el seguimiento del reajuste y/o la observación. */
export async function actualizarFilaPlanilla(id, cambios) {
    const { data } = await apiClient.patch(`/planilla-historica/${id}`, cambios);
    return data;
}
